/* Fresca — before/after: drag feedback + "drag to compare" hint that retires after the first real interaction.
   Position (--pos) itself is driven by fresca.js ([data-ba] + .fr-ba__range). */
(() => {
  'use strict';
  const init = (ba) => {
    if (!ba || ba.dataset.baReady) return;
    const range = ba.querySelector('.fr-ba__range');
    if (!range) return;
    ba.dataset.baReady = '1';
    const touched = () => ba.classList.add('is-touched');
    const down = () => { ba.classList.add('is-dragging'); touched(); };
    const up = () => ba.classList.remove('is-dragging');
    range.addEventListener('pointerdown', down);
    range.addEventListener('touchstart', down, { passive: true });
    range.addEventListener('input', touched);
    range.addEventListener('keydown', touched);
    ['pointerup', 'pointercancel', 'touchend', 'touchcancel', 'blur'].forEach((t) => range.addEventListener(t, up, { passive: true }));
    addEventListener('pointerup', up, { passive: true });
  };
  const boot = (scope = document) => scope.querySelectorAll('.fr-ba [data-ba]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot());
  else boot();
  document.addEventListener('shopify:section:load', (e) => boot(e.target));
})();
